import * as React from 'react';
import { flow } from 'lodash';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { Col, Modal, Button, FormGroup, Form } from 'react-bootstrap';
import { IChannel, ITraveller } from '../../../../../../data/api/models';
import FieldFormControl from '../../../../../../components/FieldFormControl';
import { isRequired, isValidPassword } from '../../../../../../util/validators';
import { IAuthState } from '../../../../../../services/auth/models';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../../../services/quote/models';
import { IStore } from '../../../../../../redux/IStore';
import FaPhone from 'react-icons/fa/phone';
import FaEnvelope from 'react-icons/fa/envelope';
import {Email} from '../../../../../../components/Email';
import {Link} from 'react-router-dom';

interface ISaveQuoteFormProps {
  travellers: ITraveller[];
  auth: IAuthState;
  quote: IQuoteState;
  password: string;
  passwordConfirmation: string;
  onGoToMyAccount: any;
  onCloseModal: any;
  handleSubmit: any;
  dispatch: any;
  change: any;
  channel: IChannel;
  isQuoteSaved: boolean;
  generalConditionsDocument?: string;
  renewal: boolean;
}

interface ISaveQuoteFormState {
  openModal: boolean;
}

class SaveQuoteForm extends React.Component<ISaveQuoteFormProps, ISaveQuoteFormState> {
  public render() {
    const {
      quote,
      channel,
      password,
      isQuoteSaved,
      onCloseModal,
      handleSubmit,
      onGoToMyAccount,
      passwordConfirmation,
      renewal,
    } = this.props;

    const customer = quote.customer;
    const customerStatus = customer && customer[0].status;
    const isNewCustomer = customerStatus === 'new';
    const quoteReference = quote.application.quoteReference;
    const disableSaveQuote = isNewCustomer && !password && !passwordConfirmation && password !== passwordConfirmation;
    const NOT_APPLICABLE = 'not applicable';

    return(
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <Modal.Body>
          {!isQuoteSaved ? (
            <div>
              {customerStatus === NOT_APPLICABLE && (
                <div>
                  <p className="margin-top">
                    Pour enregistrer votre devis, vous devez créer un compte.
                  </p>
                  <p>
                    Pour des raisons de sécurité, nous vous invitons à configurer votre mot de passe en respectant le
                    format suivant : 10 caractères minimum comportant au moins une lettre capitale et un caractère
                    spécial ($ ou ! Par exemple)
                  </p>
                  <FormGroup>
                    <Col sm={12}  className="">
                      <div className="manual-field-label">
                        <strong>Mot de passe</strong>
                      </div>
                      <Field
                        name="password"
                        type="password"
                        placeholder="Mot de passe"
                        component={FieldFormControl}
                        validate={[isRequired, isValidPassword]}
                      />
                    </Col>
                    <Col sm={12} className="margin-top">
                      <div className="manual-field-label">
                        <strong>Confirmez votre mot de passe</strong>
                      </div>
                      <Field
                        name="passwordConfirmation"
                        type="password"
                        placeholder="Confirmez votre mot de passe"
                        component={FieldFormControl}
                        validate={[isRequired]}
                      />
                    </Col>
                  </FormGroup>
                  <p>
                    <strong>En créant votre espace personnel, vous acceptez les&nbsp;
                      <Link to="/general-conditions" target={'_blank'}>
                        conditions générales d'utilisation</Link> du site.</strong>
                  </p>
                </div>
              )}
              {customerStatus === 'pending' || customerStatus === 'new' && (
                <div>
                  <p>Nous avons remarqué que vous avez déjà un compte avec nous, nous sommes ravis de vous revoir !</p>
                  <p>Votre devis a été enregistré dans votre espace personnel.</p>
                  <h4>Reference: {quoteReference}</h4>
                  <p>Vous pouvez accéder à votre compte à tout moment pour consulter votre devis ou vos documents.</p>
                </div>
              )}
              {customerStatus === 'active' && !isQuoteSaved && (
                <div>
                  <p>Pour enregistrer votre devis dans votre espace personnel, cliquez sur Sauvegarder.</p>
                </div>
              )}
            </div>
          ) : (
            <div>
              {renewal ? (
                <div>
                  <p>Votre devis de renouvellement est sauvegardé.
                    Vous pouvez le finaliser en vous connectant à votre espace personnel.</p>
                </div>
              ) : (
                <div>
                  <h3>Votre référence de devis est <strong>{quoteReference}</strong></h3>
                  <br/>
                  <div>
                    <p>Merci d’avoir demandé un devis RC Professionnelle.</p>
                    <p>Vous pouvez accéder à votre compte à tout moment pour consulter votre documentation.</p>
                  </div>
                </div>
              )}
              <p>Si vous avez des questions concernant votre devis, veuillez nous contacter:</p>
              <br/>
              <p id={'save-quote-contact-methods'}>
                <span><FaEnvelope/><Email email={'rcpro.france@msamlin.com'}/></span>
                <span><FaPhone/>+33 (0)1 44 70 71 00</span>
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          {!isQuoteSaved ? (
            <div>
              <div>
                <Button
                  bsStyle="primary"
                  type="submit"
                  disabled={disableSaveQuote}
                >
                  Sauvegarder
                </Button>
                <Button
                  bsStyle="primary"
                  onClick={onCloseModal}
                >
                  Annuler
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <Button
                bsStyle="primary"
                onClick={onGoToMyAccount}
              >
                Mon compte
              </Button>
              <Button
                bsStyle="primary"
                onClick={onCloseModal}
              >
                Fermer
              </Button>
            </div>
          )}
        </Modal.Footer>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.passwordConfirmation !== values.password) {
    errors.passwordConfirmation = 'Le mot de passe ne correspond ' +
      'pas à celui saisi précédemment, merci de le saisir à nouveau';
  }
  return errors;
};

let selector;

export default flow([
  reduxForm({
    form: 'save_quote',
    validate,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('save_quote');

    return component;
  },
  connect(
    (state: IStore) => {
      const password = selector(state, 'password');
      const passwordConfirmation =  selector(state, 'passwordConfirmation');

      return {
        password,
        passwordConfirmation,
        auth: state.auth,
        quote: state.quote,
        channel: state.branding.channel,
      };
    },
  ),
])(SaveQuoteForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/SaveQuoteModal/components/SaveQuoteModalForm/index.tsx